import { observable, syncedCrud } from '@/libs/state'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { User, UserPort } from '../domain/user'

// Secondary adapter: wraps UserPort in a syncedCrud observable.
// Auto-fetches on first access. Depends only on the port interface - no PocketBase knowledge.
const makeSyncedUsers = (port: UserPort, notify: NotifyPort) =>
	observable(
		syncedCrud<User, User, 'array'>({
			list: () => port.list(),
			as: 'array',
			fieldId: 'id',
			initial: [] as User[],
			onError: (_err, { source }) => {
				if (source === 'list') notify.error('member.loadFailed')
			},
		}),
	)

export { makeSyncedUsers }
